import { render, staticRenderFns } from "./ArboDocs.vue?vue&type=template&id=b8e4248c&scoped=true&"
import script from "./ArboDocs.vue?vue&type=script&lang=js&"
export * from "./ArboDocs.vue?vue&type=script&lang=js&"
import style0 from "./ArboDocs.vue?vue&type=style&index=0&id=b8e4248c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e4248c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/app/site2/src/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8e4248c')) {
      api.createRecord('b8e4248c', component.options)
    } else {
      api.reload('b8e4248c', component.options)
    }
    module.hot.accept("./ArboDocs.vue?vue&type=template&id=b8e4248c&scoped=true&", function () {
      api.rerender('b8e4248c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Portefeuille/ArboDocs.vue"
export default component.exports